import { ORDER_COMPLETED } from "areas/checkout/store/actions"

import {
  DELETE_SAVED_CART,
  SET_CART,
  SHOW_LINE_ITEM_DETAILS,
  TOGGLE_GIFT,
  ENTER_COUPON,
  UPDATE_GIFT_PROPERTIES,
  SET_GIFT_PROPERTIES,
  SET_WARRANTY,
  TOGGLE_SAVED_ITEM_ALERT,
  TOGGLE_CART_PREVIEW,
  SET_GREETING_CARD,
  SET_GIFT_WRAPPING,
  SET_GIFT_WRAP_AND_GREETING_CARD,
} from "./actions"

const INITIAL_STATE = {
  addons: [],
  cartLoaded: false,
  count: 0,
  err_msg: null,
  free_gift_offers: [],
  line_items: [],
  premium_gift_offers: [],
  summary: {},
}

export default function cartReducer(state = INITIAL_STATE, action) {
  let newState = Object.assign({}, state)

  switch (action.type) {
    case SET_CART:
      Object.keys(action.cart).map((key) => {
        newState[key] = action.cart[key]
      })
      return newState

    case SHOW_LINE_ITEM_DETAILS:
      return {
        ...newState,
        show_line_item_details: action.id
          ? newState.show_line_item_details.includes(action.id)
            ? newState.show_line_item_details.filter((id) => id !== action.id)
            : [...newState.show_line_item_details, action.id]
          : [],
      }
    case TOGGLE_GIFT: {
      let line_items = newState.line_items.map((item) => {
        if (item.id === action.id) {
          let details = Object.assign({}, item.is_gift_details, {
            toggled: !item.is_gift_details.toggled,
          })
          return {
            ...item,
            is_gift_details: details,
          }
        }
        return item
      })

      return {
        ...newState,
        line_items: line_items,
      }
    }
    case ENTER_COUPON:
      newState.summary.promo_code_entered = action.coupon_code
      return newState
    case SET_GIFT_PROPERTIES:
    case UPDATE_GIFT_PROPERTIES: {
      let line_items = newState.line_items.map((item) => {
        if (item.id === action.lineItemId) {
          return {
            ...item,
            gift_properties: {
              ...item.gift_properties,
              ...action.values,
            },
          }
        }
        return item
      })
      return {
        ...newState,
        line_items: line_items,
      }
    }
    case TOGGLE_CART_PREVIEW:
      newState.showSidebar = action.toggle
      return newState
    case TOGGLE_SAVED_ITEM_ALERT:
      newState.showSavedItemAlert = action.toggle
      return newState
    case ORDER_COMPLETED:
    case DELETE_SAVED_CART:
      newState = INITIAL_STATE
      return newState
    case SET_WARRANTY:
      // Optimistically update warranty in state before API response
      return {
        ...newState,
        line_items: newState.line_items.map((li) => {
          if (li.id === action.payload.line_item_id) {
            return {
              ...li,
              addons: [
                ...(li.addons || []).filter(
                  (addon) => addon.addon_type !== "WARRANTY"
                ),
                ...(Object.keys(action.payload.plan || {}).length > 0
                  ? [
                      {
                        addon_code: action.payload.plan?.id,
                        addon_type: "WARRANTY",
                        currency_code: li.currency_code,
                        image_url: action.payload.plan?.imageUrl,
                        price: action.payload.plan?.price,
                        retail_price: action.payload.plan?.price,
                        title: `${action.payload.plan?.title} - ${action.payload.plan?.duration}`,
                      },
                    ]
                  : []),
              ],
            }
          }

          return li
        }),
      }
    case SET_GREETING_CARD:
      // Optimistically update greeting card in state before API response
      return {
        ...newState,
        line_items: newState.line_items.map((li) => {
          const { line_item_id, ...greetingCardData } = action.payload || {}
          if (li.id === line_item_id) {
            return {
              ...li,
              addons: [
                ...(li.addons || []).filter(
                  (addon) => addon.addon_type !== "GREETING_CARD"
                ),
                ...(Object.keys(greetingCardData || {}).length > 0
                  ? [
                      {
                        ...greetingCardData,
                        addon_type: "GREETING_CARD",
                        title: `${greetingCardData?.title} Greeting Card`,
                      },
                    ]
                  : []),
              ],
            }
          }

          return li
        }),
      }
    case SET_GIFT_WRAPPING:
      // Optimistically update gift wrap in state before API response
      return {
        ...newState,
        line_items: newState.line_items.map((li) => {
          const { line_item_id, ...giftWrapData } = action.payload || {}
          if (li.id === line_item_id) {
            return {
              ...li,
              addons: [
                ...(li.addons || []).filter(
                  (addon) => addon.addon_type !== "PACKAGING"
                ),
                ...(Object.keys(giftWrapData || {}).length > 0
                  ? [
                      {
                        ...giftWrapData,
                        addon_type: "PACKAGING",
                      },
                    ]
                  : []),
              ],
            }
          }

          return li
        }),
      }
    case SET_GIFT_WRAP_AND_GREETING_CARD:
      // Optimistically update gift wrap & greeting card in state before API response
      return {
        ...newState,
        line_items: newState.line_items.map((li) => {
          const { line_item_id, gift_wrap, greeting_card } =
            action.payload || {}
          if (li.id === line_item_id) {
            return {
              ...li,
              addons: [
                ...(li.addons || []).filter(
                  (addon) =>
                    addon.addon_type !== "GREETING_CARD" &&
                    addon.addon_type !== "PACKAGING"
                ),
                ...(Object.keys(gift_wrap || {}).length > 0
                  ? [
                      {
                        ...gift_wrap,
                        addon_type: "PACKAGING",
                      },
                    ]
                  : []),
                ...(Object.keys(greeting_card || {}).length > 0
                  ? [
                      {
                        ...greeting_card,
                        addon_type: "GREETING_CARD",
                        title: `${greeting_card?.title} Greeting Card`,
                      },
                    ]
                  : []),
              ],
            }
          }

          return li
        }),
      }
    default:
      return state
  }
}
